module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_19.656113c5.png";